/* eslint-disable */
import { userActionTypes } from "./actionTypes";

export const setAllUsers = (payload) => {
  return {
    type: userActionTypes.SET_ALL_USERS,
    payload,
  };
};

export const updateSingleUser = (payload) => {
  return {
    type: userActionTypes.UPDATE_SINGLE_USER,
    payload,
  };
};
